module.exports = __webpack_public_path__ + "static/media/speaker.bbb579c7.svg";